<template>
<div class="form-step-item">
    <div class="panel">
        <div class="intro">
            <h3>Ambulatory Pump Training</h3>
            <p>Please allow at least 2 weeks notice for pump training to be scheduled, this allows for hardware delivery prior to training.</p>
        </div>
        <div class="form-row">
            <div class="form-group col-4 pump-radio">
                <h5 class="label">Is pump training required?</h5>
                <div class="bax-boxed-radio">
                    <div class="bax-radio">
                        <input type="radio" id="pump_training_yes" class="css-checkbox" value="yes" v-model="formData.pump_training" />
                        <label for="pump_training_yes" class="css-label">Yes</label>
                    </div>
                    <div class="bax-radio">
                        <input type="radio" id="pump_training_no" class="css-checkbox" value="no" v-model="formData.pump_training" />
                        <label for="pump_training_no" class="css-label">No</label>
                    </div>
                </div>
                <span class="form-error" v-if="$v.formData.pump_training.$dirty && !$v.formData.pump_training.required">Required field</span>
            </div>
            <div class="form-group col-4" v-if="formData.pump_training === 'yes'">
                <label for="date_discharge">Estimated date of discharge *</label>
                <DateEntry class="form-control" v-model="formData.date_discharge"></DateEntry>
                <span class="form-error" v-if="$v.formData.date_discharge.$dirty && !$v.formData.date_discharge.required">Required field</span>
                <span class="form-error" v-if="$v.formData.date_discharge.$dirty && !$v.formData.date_discharge.pastDate">Date not valid</span>
            </div>
            <div class="form-group col-4" v-if="formData.pump_training === 'yes'">
                <label for="date_training">Requested date for training *</label>
                <DateEntry class="form-control" v-model="formData.date_training"></DateEntry>
                <span class="form-error" v-if="$v.formData.date_training.$dirty && !$v.formData.date_training.required">Required field</span>
                <span class="form-error" v-if="$v.formData.date_training.$dirty && !$v.formData.date_training.pastDate">Date not valid</span>
            </div>
        </div>
    </div>
</div>
</template>


<script>

import { required, requiredIf } from 'vuelidate/lib/validators';
import moment from 'moment';
import DateEntry from '@/components/ui/DateEntry.vue';

export default {
    name: 'FormStep6',
    components: {
        DateEntry,
    },
    props: {
        formData: {
            required: true,
        },
    },
    data() {
        return {
        };
    },
    validations: {
        formData: {
            pump_training: {
                required,
            },
            date_discharge: {
                required: requiredIf(function () {
                    if (this.formData.pump_training === 'yes') {
                        return true;
                    }
                    return false;
                }),
                pastDate(val) {
                    if (val === '') {
                        return true;
                    }
                    if (moment(val, ['DD/MM/YYYY', 'D/M/YYYY'], true).isValid() === false) {
                        return true;
                    }
                    const today = moment().format('DD/MM/YYYY');
                    const now = moment(today, 'DD/MM/YYYY');
                    const date = moment(val, 'DD/MM/YYYY');

                    if (date.diff(now, 'days') <= 0) {
                        return false;
                    }

                    return true;
                },
            },
            date_training: {
                required: requiredIf(function () {
                    if (this.formData.pump_training === 'yes') {
                        return true;
                    }
                    return false;
                }),
                pastDate(val) {
                    if (val === '') {
                        return true;
                    }
                    if (moment(val, ['DD/MM/YYYY', 'D/M/YYYY'], true).isValid() === false) {
                        return true;
                    }
                    const today = moment().format('DD/MM/YYYY');
                    const now = moment(today, 'DD/MM/YYYY');
                    const date = moment(val, 'DD/MM/YYYY');

                    if (date.diff(now, 'days') <= 0) {
                        return false;
                    }

                    return true;
                },
            },
        },
    },
    computed: {
    },
    methods: {
        validateForm() {
            this.$v.$touch();
            this.$emit('validation_response', !this.$v.$invalid);
        },
    },
};
</script>
